import styled from "@emotion/styled";
import { theme } from "styles/theme";

export const DropdownContainer = styled.div`
  border-bottom: 1px solid ${theme.neutral100};
  display: flex;
  justify-content: space-between;
  padding: 20px 24px;

  cursor: pointer;
`;

export const DropdownLabel = styled.p`
  color: ${theme.neutral900};
  font-size: 17px;
  font-weight: 700;
`;

export const DropdownIcon = styled.div<{ open?: boolean }>`
  rotate: ${(props) => (props.open ? "180deg" : 0)};
  display: flex;
  align-items: center;

  transition: all 0.5s ease;
`;

export const Annotation = styled.p`
  color: ${theme.neutral500};
  font-size: 14px;
  font-weight: 500;
  padding: 12px 24px;
`;

export const TabContainer = styled.div`
  background-color: ${theme.neutral50};
  padding: 16px 24px;
  display: flex;
  gap: 12px;
`;
export const TabBtn = styled.div<{ isPressed?: boolean }>`
  padding: 12px 24px;
  border-radius: 100px;
  background: ${(props) => (props.isPressed ? theme.primary500 : "white")};
  color: ${(props) => (props.isPressed ? "white" : theme.primary500)};

  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
`;

export const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MessageContainer = styled.div`
  padding: 24px;
  gap: 12px;
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
  }
`;

export const Title = styled.p`
  color: ${theme.neutral900};
  font-size-adjust: 17px;
  font-weight: 700;
`;

export const Container = styled.div`
  box-sizing: border-box;
  min-width: 1060px;
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
`;

export const Heading = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  align-self: stretch;
`;
